


export async function fetchParcelBoundaryFromLINZ(lat, lng) {
    const url = `https://api.data.linz.govt.nz/api/vectorQuery.json?key=c5ba8bc5f887465ea1672eded3f699df&layer=50804&x=${lng}&y=${lat}&max_results=1&radius=10&geometry=true&with_field_names=true`;

    try {
        const response = await fetch(url);
        const data = await response.json();

        const features = data?.vectorQuery?.layers?.[50804]?.features;

        if (features && features.length > 0) {
            const geometry = features[0].geometry;
            const landProps = features[0].properties;

            return { geometry, landProps };
        }
        return null;

    } catch (error) {
        console.error('Error querying LINZ:', error);
        return null;
    }
}



